import React from "react";
import { Link } from "react-router-dom";
import "../styles/Marketplace.css";

const Marketplace = () => {
    return (
        <div className="marketplace">
            <h1>Wisdom Academy Marketplace</h1>
            <p>Manage your tokens, rewards, and transactions.</p>

            <div className="marketplace-links">
                <Link to="/marketplace/buytokens" className="marketplace-card">
                    Buy Tokens
                    <small>Purchase WSD on the Wisdom chain (2307).</small>
                </Link>
                <Link to="/marketplace/earnrewards" className="marketplace-card">
                    Earn Rewards
                    <small>Claim course and activity rewards in WSD.</small>
                </Link>
                <Link to="/marketplace/mytransactions" className="marketplace-card">
                    My Transactions
                    <small>Review token movements for this wallet.</small>
                </Link>
            </div>
        </div>
    );
};

export default Marketplace;